// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".js-close-popup[data-v-006a0262]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
